import { render, staticRenderFns } from "./NewProductExtraAdd.vue?vue&type=template&id=ea6e3b5a"
import script from "./NewProductExtraAdd.vue?vue&type=script&lang=js"
export * from "./NewProductExtraAdd.vue?vue&type=script&lang=js"
import style0 from "./NewProductExtraAdd.vue?vue&type=style&index=0&id=ea6e3b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports